import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPipe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPipe"><Path d="M9 19H11V12H19V19H21V21H3V19H5V12H9V19Z" fill="currentColor"/><Path d="M7 10H3V3H7V10Z" fill="currentColor"/><Path d="M21 10H9V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPipe;
